/**
 * String keys required for the ConsentBanner component.
 */
export const consentBannerStringKeys = [
  'title',
  'declineAllSectionA',
  'declineAllSectionB',
  'declineAllSectionC',
  'declineAllButtonAcceptAll',
  'declineAllButtonManageSettings',
  'declineAllButtonAcceptEssentialOnly',
] as const;

/**
 * Optional string keys accepted but not rendered by ConsentBanner.
 *
 * These are deprecated CookieBanner keys (`explainYourOptions`,
 * `consentInformationSectionA/B/D`) that consumers may still pass in
 * the shared `strings` object. Listing them here prevents
 * `StringsPropVerification` from logging warnings for unexpected keys.
 * ConsentBanner does not use or render any of these values.
 */
export const consentBannerOptionalStringKeys = [
  'explainYourOptions',
  'consentInformationSectionA',
  'consentInformationSectionB',
  'consentInformationSectionD',
] as const;
